// extracted by mini-css-extract-plugin
export default {"AdhdTitle1":"iStyles_AdhdTitle1__EB3Rc","AdhdTitle1_":"iStyles_AdhdTitle1___qvIBt","AdhdTitle2":"iStyles_AdhdTitle2__DRkEZ","AdhdTitle3":"iStyles_AdhdTitle3__EvcZh"};